<header-title [model]="headerTitle"></header-title>

<div class="row">
    <div class="col">
        <button class="btn btn-primary" type="button" [routerLink]="['/brokers/add']">Add New Broker</button>
    </div>
</div>

<section class="panel">
    <div class="row my-3">
        <div class="col col-md-6">
            <header class="panel-heading">
                <h3 class="text-gray-600 m-0">Existing Brokers</h3>
            </header>
        </div>
        <div class="col col-md-6 pt-3">
            <div class="row align-items-center">
                <div class="col col-md-2 text-right">
                    <label class=" control-label">Filter:</label>
                </div>
                <div class="col-md-10">
                    <form [formGroup]="filterForm" *ngIf="filterForm">
                        <input type="text" class="form-control filter-input" formControlName="filterText" placeholder="Start typing to filter list" />
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="panel-body">
        <div class="table-responsive">
            <table class="table table-hover mb-none">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Company</th>
                        <th>Name</th>
                        <th class="text-center">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let broker of brokersList;index as i">
                        <td>{{i+1}}</td>
                        <td>{{broker.companyName}}</td>
                        <td>{{broker.name}}</td>
                        <td class="actions text-center">
                            <a (click)="selectedBrokerId=broker.id; confirmation.showMessage();"><i class="fa fa-trash text-danger"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>

<app-confirmation-message #confirmation (confirmationClicked)="deleteBroker();"
                          [title]="'Confirmation'"
                          [message]="'Are you sure you want to remove this broker?'">
</app-confirmation-message>
